import { useTranslation } from 'next-i18next'
import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { t } from 'localization'
import { Button } from 'shared/components/Button'
import Divider from 'shared/components/Divider'
import PanelBox from 'shared/components/Panel/PanelBox'
import { UserAuthQA } from 'shared/dataAttributes'
import { fonts } from 'shared/lib'

const TP = 'password.EmailSentPanel'

type EmailSentPanelProps = {
  email: string
  onBackToResetPassword: () => void
}

const EmailSentPanel = ({ email, onBackToResetPassword }: EmailSentPanelProps) => {
  const tv = useTranslation()

  return (
    <PanelBox>
      <FlexColumn>
        <Title data-qa={UserAuthQA.EmailSentHeader}>{t(`${TP}.emailSent`, 'Email Sent')}</Title>
        <SubTitle>
          <Trans
            components={[<Email data-qa={UserAuthQA.EmailSentEmailText} />]}
            defaults="If there is an account associated with <0> {email} </0> you will receive an email with a link to reset your password."
            i18nKey={`${TP}.subTitle`}
            t={tv.t}
            values={{ email }}
          />
        </SubTitle>
        <Divider />
        <Button
          as="a"
          buttonType="primary1"
          $fill
          href="/customer/account/login"
          qaAttr={UserAuthQA.EmailSentLoginButton}
        >
          {t(`${TP}.login`, 'Login')}
        </Button>
        <BackButton
          buttonType="secondary"
          $fill
          onClick={onBackToResetPassword}
          qaAttr={UserAuthQA.EmailSentBackToResetPasswordButton}
        >
          {t(`${TP}.back`, 'Back To Reset Password')}
        </BackButton>
      </FlexColumn>
    </PanelBox>
  )
}

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

const BackButton = styled(Button)`
  margin-top: 15px;
`

const Title = styled.h3`
  ${fonts.SUBTITLE_3}
  font-weight: unset;
  margin: 0 0 10px;
`

const SubTitle = styled.h4`
  ${fonts.BODY_TEXT}
  margin: 0;
  font-weight: unset;
`

const Email = styled.span`
  ${fonts.CTA_TEXT_2}
`

export default EmailSentPanel
